import { store } from '@betacrew/jars-flux'
import { APP_SWITCH_STATES } from './constants';

export const componentKey = "APP_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.appSwitchLoaderState = action.payload;
        },
        setRedirectUrl: (state, action) => {
            state.redirectUrl = action.payload;
        },
    },
    initialReducerState: {
        appSwitchLoaderState: { state: APP_SWITCH_STATES.APP_SWITCH_LOADING },
        redirectUrl: null
    }
});
export const { setLoadingState, setRedirectUrl } = actions;